// Premium Luxury Vivah Nepal Logo - Royal Golden Union & Lotus Crown SVG Design
import React from 'react';

export function VivahLogoIcon({ size = 32 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="vivah-logo-icon"
    >
      <defs>
        <linearGradient id="goldRoyalGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F7D070" />
          <stop offset="50%" stopColor="#C59B27" />
          <stop offset="100%" stopColor="#8E202B" />
        </linearGradient>
        <linearGradient id="goldShine" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#AA771C" />
          <stop offset="50%" stopColor="#F9E29C" />
          <stop offset="100%" stopColor="#9E1B32" />
        </linearGradient>
        <filter id="glowEffect" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="2" stdDeviation="2.5" floodColor="#C59B27" floodOpacity="0.4" />
        </filter>
      </defs>
      
      {/* Outer Halo */}
      <circle cx="27" cy="27" r="24" stroke="url(#goldRoyalGrad)" strokeWidth="1" strokeDasharray="3 3" opacity="0.5" />
      
      {/* Interlocking Golden Rings */}
      <circle cx="19" cy="27" r="11" fill="none" stroke="url(#goldShine)" strokeWidth="3" filter="url(#glowEffect)" />
      <circle cx="35" cy="27" r="11" fill="none" stroke="url(#goldRoyalGrad)" strokeWidth="3" filter="url(#glowEffect)" />
      
      {/* Lotus / Diamond Central Crest */}
      <path d="M27 15 L31 27 L27 39 L23 27 Z" fill="url(#goldRoyalGrad)" />
      <circle cx="27" cy="27" r="3.5" fill="#FFFFFF" opacity="0.9" />
      
      {/* Royal Crown Accent */}
      <circle cx="27" cy="8" r="2.5" fill="url(#goldShine)" />
    </svg>
  );
}

export default function VivahLogo({ size = 'medium' }) {
  const isLarge = size === 'large';
  const width = isLarge ? 220 : 190;
  const height = isLarge ? 64 : 54;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 220 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="vivah-logo"
    >
      <defs>
        <linearGradient id="logoGold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F9E29C" />
          <stop offset="40%" stopColor="#D4AF37" />
          <stop offset="80%" stopColor="#AA771C" />
          <stop offset="100%" stopColor="#9E1B32" />
        </linearGradient>
        <linearGradient id="rubyAccent" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#C53030" />
          <stop offset="100%" stopColor="#800020" />
        </linearGradient>
        <filter id="logoGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#D4AF37" floodOpacity="0.35" />
        </filter>
      </defs>

      {/* Decorative Royal Ring & Lotus Emblem */}
      <g transform="translate(4, 2)" filter="url(#logoGlow)">
        {/* Outer Fine Crest Circle */}
        <circle cx="26" cy="28" r="23" stroke="url(#logoGold)" strokeWidth="1" opacity="0.4" strokeDasharray="4 2" />
        
        {/* Intertwined Couple Rings */}
        <circle cx="18" cy="28" r="11" fill="none" stroke="url(#logoGold)" strokeWidth="3.2" />
        <circle cx="34" cy="28" r="11" fill="none" stroke="url(#logoGold)" strokeWidth="3.2" />
        
        {/* Center Union Diamond */}
        <path d="M26 18 L30 28 L26 38 L22 28 Z" fill="url(#logoGold)" />
        <circle cx="26" cy="28" r="3" fill="url(#rubyAccent)" />

        {/* Lotus Top Crown Accent */}
        <path d="M26 6 L29 12 L26 10 L23 12 Z" fill="url(#logoGold)" />
        <circle cx="26" cy="5" r="1.8" fill="url(#logoGold)" />
      </g>

      {/* Brand Name Text: Vivah */}
      <text
        x="68"
        y="36"
        fontFamily="'Cormorant Garamond', 'Playfair Display', Georgia, serif"
        fontSize="34"
        fontWeight="700"
        fill="url(#logoGold)"
        letterSpacing="3"
      >
        Vivah
      </text>

      {/* Tagline: NEPAL */}
      <text
        x="70"
        y="49"
        fontFamily="'Outfit', 'DM Sans', sans-serif"
        fontSize="10"
        fontWeight="600"
        fill="#C59B27"
        letterSpacing="6.5"
        opacity="0.9"
      >
        NEPAL
      </text>

      {/* Delicate Accent Dots */}
      <circle cx="162" cy="46" r="1.2" fill="url(#logoGold)" />
      <circle cx="174" cy="46" r="1.2" fill="url(#logoGold)" />
      <circle cx="186" cy="46" r="1.2" fill="url(#logoGold)" />
    </svg>
  );
}
